import * as fromActions from '../actions/atencion.action';
import { AtencionData } from '../models/store.model';

export const atencionInitialState: AtencionData | null = null;

export function atencionDataReducer(
    state = atencionInitialState,
    action: fromActions.AtencionDataActions
): AtencionData | null {
    switch (action.type) {
        case fromActions.SETATENCIONDATA:
            return { ...state, ...action.atencion };

        case fromActions.UNSETATENCIONDATA:
            return null;

        default:
            return state;
    }
}
